module.exports = __webpack_public_path__ + "static/img/fish28.d1a2816.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish28.png
// module id = /oJU
// module chunks = 0